// extracted by mini-css-extract-plugin
export var hero = "HeroImage-module--hero--sgapy";
export var padderLeft = "HeroImage-module--padderLeft--3Mt2b";
export var text = "HeroImage-module--text--2_n9M";
export var image = "HeroImage-module--image--2fEqu";